// Validação de formato de e-mail. Mesma regra usada nas telas de login e
// cadastro (pages/login/index.js e pages/novo-cadastro/index.js), reaproveitada
// aqui para decidir se a receita deve ser enviada automaticamente ao produtor
// (enviar_receita = 1 quando o e-mail informado é válido).
const validadorDeEmail = (email) => {
    if (!email || typeof email !== 'string') return false;
    const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
    return regex.test(email.trim());
}

export default validadorDeEmail;
